export default __webpack_public_path__ + "static/media/ChandosBook.32139bd6.jpg";